import { Component, OnInit } from '@angular/core';

import { IBulkEntryType } from '../../scripts/timesheet';
import { DatahubService } from '../../services/datahub.service';

@Component({
  selector: 'labor',
  templateUrl: './labor.component.html',
  standalone: false,
})
export class LaborComponent implements OnInit {
  public readonly timeSheet = this.datahub.timesheet;

  constructor(private readonly datahub: DatahubService) {}

  public ngOnInit(): void {
    this.datahub.costCenter.setCostCenterValueWithString(this.datahub.extDocument.Costcenter1, true);
    this.timeSheet.currentEmployeeCrew = this.timeSheet.currentEmployeeCrew.sort((a, b) => {
      return a.LastName > b.LastName ? 1 : -1;
    });
  }

  public bulkEntry(type: IBulkEntryType): void {
    this.timeSheet.bulkEntryEmployees(type);
  }
}
